<div class="panel__header">
  <span class="panel__header__title" style="font-size: 20px;">
          Implement Summary
  </span>
</div>
<div class="panel__sub-header panel__content no-padding" >

<div class="column-container flex-grow">
  <div class="column-container__column">
      <!-- <img *ngIf="system.SystemType == 'Chain'" class="chain-photo" src="/Content/Images/chain.jpg" alt="Chain" /> -->
      <!-- <img *ngIf="system.SystemType == 'Frame'" class="chain-photo" src="/Content/Images/frame.jpg" alt="Chain" /> -->
     
  </div>
  <div class="column-container__column">
      <div class="text-block">
          <span class="text-block__important" style="    font-size: 18px; ">  {{Implemetdetails.Name}}
                  <!-- <a routerLink="/implementdetails/{{Implemetdetails.Id}}">
          </a> -->
          </span>
      </div>
  </div>
  <div class="column-container__column">
      <div class="text-block">
          <span class="text-block__label">
              % Worn - Normal
          </span>
          <span class="text-block__important {{getEvalClass(Implemetdetails.WorstNormalWorn)}}" >
           {{Implemetdetails.WorstNormalWorn}}%
          </span>
      </div>
  </div>
  <div class="column-container__column">
      <div class="text-block">
          <span class="text-block__label">
           #Crack/Length
          </span>
          <span class="text-block__important">
            {{Implemetdetails.TotalCracks}}/{{Implemetdetails.TotalCrackLength}}
          </span>
          <!-- <span class="text-block__important {{getEvalClass(Implemetdetails.WorstCrackWorn)}}" style="    margin-left: 53px;
          margin-top: -20px;" >
              {{Implemetdetails.WorstCrackWorn}}%
             </span> -->
      </div>
  </div>
  <div class="column-container__column">
      <div class="text-block">
          <span class="text-block__label">
              % Worn - Crack
          </span>
          <span class="text-block__important {{getEvalClass(Implemetdetails.WorstCrackWorn)}}" >
           {{Implemetdetails.WorstCrackWorn}}%
          </span>
      </div>
  </div>
  <div class="column-container__column">
      <div class="text-block">
          <span class="text-block__label">
          Life
          </span>
          <span class="text-block__important">
        {{ Implemetdetails.Life}}
          </span>
      </div>
  </div>
  <div class="column-container__column">
      <div class="text-block">
          <span class="text-block__label">
            Residual
          </span>
          <span class="text-block__important">
           {{Implemetdetails.Residual}}
          </span>
      </div>
  </div>
  <!-- <div class="column-container__column">
      <div class="text-block">
          <span class="text-block__label">
            Purchase Cost
          </span>
          <span class="text-block__important">
           $ {{Implemetdetails.PurchaseCost}}
          </span>
      </div>
  </div> -->
  <div class="column-container__column">
      <div class="text-block">
          <span class="text-block__label">
             Total Cost
          </span>
          <span class="text-block__important">
           $ {{Implemetdetails.RepairCost}}
          </span>
      </div>
  </div>
</div>
</div>